export class EventExpiry {
  constructor() {
    this._checkRedirect()
    this._hideExpired()
  }

  _isExpired(dateStr) {
    const until = new Date(dateStr)
    until.setHours(23, 59, 59, 999)
    return Date.now() > until.getTime()
  }

  _checkRedirect() {
    const el = document.querySelector('[data-publish-until][data-publish-until-redirect]')
    if (!el) return
    if (this._isExpired(el.dataset.publishUntil)) {
      location.replace(el.dataset.publishUntilRedirect)
    }
  }

  _hideExpired() {
    document.querySelectorAll('[data-publish-until]:not([data-publish-until-redirect])').forEach((el) => {
      if (this._isExpired(el.dataset.publishUntil)) {
        el.style.display = 'none'
      }
    })
  }
}
